import React from 'react';
import { Button } from '@mui/material';
import { styled, useTheme } from '@mui/system';

// Define the button styles using the styled function
const CustomStyledButton = styled(Button)(({ theme, variant, size }) => {
  console.log("variant", variant);
  const isClearVariant = variant === 'outlined' || variant === 'text';

  // Adjust styles based on the size prop
  const sizeStyles = {
    small: {
      width: isClearVariant ? '140px' : '180px',
      height: '36px',
    },
    medium: {
      width:  "108px",
      height: '48px',
    },
    large: {
      width:  "180px",
      height: '38px',
    },
  };

  return {
    ...sizeStyles[size], // Apply size-specific styles
    padding: theme.spacing(1, 2),
    gap: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: isClearVariant ? 'transparent' : theme.palette.primary.main,
    color: isClearVariant ? theme.palette.primary.main : theme.palette.primary.contrastText,
    border: isClearVariant ? '1px solid #3E8A5D' : '1px solid transparent',
    boxShadow: isClearVariant ? '0px 4px 12px 4px #E9E9E980' : 'none',

    '&:hover': {
      backgroundColor: isClearVariant ? 'transparent' : theme.palette.primary.dark,
      opacity: isClearVariant ? 1 : 0.9,
    },
    '&:focus': {
      outline: `2px solid ${theme.palette.primary.main}`,
    },
  };
});

const CustomButton = ({ onClick, title, variant, size , ...props }) => {
  const theme = useTheme(); // Access the theme

  return (
    <CustomStyledButton
      onClick={onClick}
      variant={variant}
      size={size} // Pass size prop to styled component
      {...props}
    >
      {title}
    </CustomStyledButton>
  );
};

export default CustomButton;
